// JsFromRoutes CacheKey ff8a1a56d78b934cf8b85eca83cfbbb3
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  promote: /* #__PURE__ */ definePathHelper('post', '/:account_id/shortcuts/clusters/:id/promote'),
  dismiss: /* #__PURE__ */ definePathHelper('post', '/:account_id/shortcuts/clusters/:id/dismiss'),
}
